import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import BrandInfo from "./BrandInfo";
import BrandDetails from "./BrandDetails";
import downArrow from "../../../../assets/images/map_v2/down-arrow-bl.svg";
import { Location, Brand, BrandList, Tier, Tag } from "../types/mapData";
// import LoadingSpinner from "./LoadingSpinner";
import BackSection from "./BackSection";

interface SidebarContainerProps {
  listState: number;
  widget?: boolean;
  filteredLocations: Location[];
  locations: Location[];
  setFilteredLocations: (locations: Location[]) => void;
  handleCurMarker: (marker?: google.maps.Marker | null) => void;
  setInfoOpenMobile: (open: boolean) => void;
  enteredThroughButton: boolean;
  colorMode: string;
  brands: BrandList | null;
  cloudinaryPath: string;
  userLocErr: boolean;
  handleBrandInfoClick: (
    location: Location,
    marker: google.maps.Marker,
    brandId?: number,
  ) => void;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  currentPage: number;
  curBrand: number;
  curLoc?: Location | null;
  tags: Tag[] | null;
  getFeaturedTags: (brand?: Brand) => string[];
  curMarker?: google.maps.Marker | null;
  tiers?: Tier[];
  ctaDisplay?: string | null;
  purchaseModeTiers?: boolean | null;
  totalLocationCount?: number | null;
  showBonusBox?: boolean | null;
  setCurLoc: (loc: Location | null) => void;
  setListState: (state: number) => void;
  loadingDetails: boolean;
  curMarkerRef?: React.RefObject<google.maps.Marker>;
  oval: string;
  counter?: number;
}

const SidebarContainer: React.FC<SidebarContainerProps> = ({
  listState,
  widget,
  filteredLocations,
  locations,
  setFilteredLocations,
  handleCurMarker,
  setInfoOpenMobile,
  enteredThroughButton,
  colorMode,
  brands,
  cloudinaryPath,
  userLocErr,
  handleBrandInfoClick,
  setCurrentPage,
  currentPage,
  curBrand,
  curLoc,
  tags,
  getFeaturedTags,
  curMarker,
  tiers,
  ctaDisplay,
  purchaseModeTiers,
  totalLocationCount,
  showBonusBox,
  setCurLoc,
  setListState,
  loadingDetails,
  curMarkerRef,
  oval,
  counter = 0,
}) => {
  const handleBonusScroll = () => {
    const bonusBoxOuter = document.getElementsByClassName(
      "bonus-outer",
    )[0] as HTMLElement;
    const scrollHeight = bonusBoxOuter?.offsetHeight;

    const scrollElement = document.getElementsByClassName(
      "info-container-inner",
    )[0];

    const brandInfoContainer = document.getElementsByClassName(
      "brand-info",
    )[0] as HTMLElement;
    const scrollToLocation =
      brandInfoContainer?.offsetHeight + 8 - scrollHeight;
    scrollElement.scrollTo({
      top: scrollToLocation,
      left: 100,
      behavior: "smooth",
    });
  };

  const handleExitMulti = () => {
    setFilteredLocations(locations);
    handleCurMarker(null);
    if (!enteredThroughButton) {
      setInfoOpenMobile(false);
    }
  };

  const handleBack = () => {
    const notMulti = filteredLocations.length === locations.length;
    setCurLoc(null);
    handleCurMarker(!!notMulti ? null : curMarker);
    setListState(1);
    if (!enteredThroughButton && !!notMulti) {
      setInfoOpenMobile(false);
    }
  };
  const hiddenLength = filteredLocations.length - currentPage * 15;
  const visibleLocations = filteredLocations?.slice(0, currentPage * 15) ?? [];

  return (
    <div
      className="info-container"
      style={{
        borderRadius: widget === true ? "24px" : "",
      }}
    >
      <div className="info-container-inner">
        {listState === 1 && (
          <div className="locations-list" id="list-1">
            {filteredLocations?.length !== locations?.length && (
              <BackSection
                widget={widget}
                handleExitMulti={handleExitMulti}
                colorMode={colorMode}
              />
            )}
            {!!brands &&
              visibleLocations?.map((location) => {
                return (
                  <BrandInfo
                    key={location.location_id}
                    location={location}
                    brandToUse={brands[location.brand_id]}
                    cloudinaryPath={cloudinaryPath}
                    userLocErr={userLocErr}
                    handleBrandInfoClick={handleBrandInfoClick}
                    tags={tags}
                    getFeaturedTags={getFeaturedTags}
                    oval={oval}
                    loadingDetails={loadingDetails}
                    curMarkerRef={curMarkerRef}
                  />
                );
              })}
            {hiddenLength > 0 && !curMarker && (
              <div
                className="show-more-brands"
                onClick={() => {
                  setCurrentPage((prev) => prev + 1);
                }}
              >
                <div className="show-more">
                  <img src={downArrow} alt="down arrow" />
                  Show {hiddenLength > 15 ? 15 : hiddenLength} more
                </div>
              </div>
            )}
          </div>
        )}
        {listState === 2 && (
          <div className="brand-info" id="list-2">
            <BackSection
              widget={widget}
              handleBack={handleBack}
              colorMode={colorMode}
            />

            <BrandDetails
              brandToUse={brands?.[curBrand]}
              curLoc={curLoc}
              tiers={tiers}
              cloudinaryPath={cloudinaryPath}
              userLocErr={userLocErr}
              ctaDisplay={ctaDisplay}
              tags={tags}
              getFeaturedTags={getFeaturedTags}
              purchaseModeTiers={purchaseModeTiers}
              brands={brands}
              totalLocationCount={totalLocationCount}
            />
          </div>
        )}
        {/* MOVE TO TRUE LOADING STATE NOT JUST BASED ON IF THERES RESULTS OR NOT */}

        {/* ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <LoadingSpinner />
          </div>
        )} */}
      </div>
      <AnimatePresence>
        {listState === 2 && !!showBonusBox && ctaDisplay !== "none" && (
          <motion.div
            className="bonus-scroll-box"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            id="bonus-box"
            exit={{ opacity: 0 }}
            onClick={handleBonusScroll}
          >
            {!!purchaseModeTiers ? (
              tiers?.length ? (
                <span>
                  Get a ${tiers[0].rounded_bonus_amount} to $
                  {tiers[tiers.length - 1].rounded_bonus_amount} bonus
                </span>
              ) : null
            ) : (
              <span>Get 20% Back Here</span>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SidebarContainer;
